import React, { useEffect, useState } from "react";
import { Autocomplete, TextField, Typography, Box, Chip } from "@mui/material";
import RequiredLabel from "./RequiredLabel";

const PrefectureSelect = ({
  value = [],
  onChange,
  label,
  max,
  isRequired = false,
  error = false,
  endpoint = "/prefecture_autocomplete",
}) => {
  const [prefectures, setPrefectures] = useState([]);

  useEffect(() => {
    const controller = new AbortController();

    const fetchPrefectures = async () => {
      try {
        const res = await fetch(endpoint, { signal: controller.signal });
        const data = await res.json();
        setPrefectures(data);
      } catch (err) {
        if (err.name === "AbortError") return;
        console.error("都道府県取得エラー:", err);
      }
    };

    fetchPrefectures();
    return () => controller.abort();
  }, [endpoint]);

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <Typography sx={{ fontSize: 14 }}>
          {label}(最大{max}つまで指定可能)
        </Typography>
        <RequiredLabel show={isRequired} />
      </Box>

      <Autocomplete
        multiple
        options={prefectures}
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        value={prefectures.filter((p) => value.includes(p.id))}
        onChange={(event, newValue) => {
          if (newValue.length <= max) {
            onChange(newValue.map((pref) => pref.id));
          }
        }}
        noOptionsText="該当する都道府県はありません"
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              key={option.id}
              variant="filled"
              label={option.name}
              {...getTagProps({ index })}
              sx={{
                backgroundColor: "#4F46E5",
                color: "white",
                "& .MuiChip-deleteIcon": {
                  color: "white",
                  "&:hover": {
                    color: "#f0f0f0",
                  },
                },
              }}
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="都道府県を選択"
            helperText="※検索は可能ですが、候補から選択してください（手入力不可）"
            FormHelperTextProps={{
              sx: {
                marginLeft: 0,
              },
            }}
            error={error}
            sx={{
              "& .MuiInputBase-input:focus": { boxShadow: "none" },
            }}
          />
        )}
      />
    </Box>
  );
};

export default PrefectureSelect;
